import SharedBaseService from './shared.base.service'

class SharedMapService extends SharedBaseService{

    async getUrlKml(token, jwt) {
        let url = `/api/v1/share/maps/${token}`;
        const header = {
            'Content-Type': 'application/json',
        }
        if (jwt){
            header['x-token'] = jwt
        }
        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: header,
                credentials: 'same-origin',
            }
        )
        if ( response.ok) {
            const data = await response.json()
            return data.urlKml;
        }
        else if ( response.status == 401) {
            throw Error("401")
        }
    }



}

const sharedMapService = new SharedMapService();

export default sharedMapService;